document.addEventListener('DOMContentLoaded', () => {
  const stopOtherAudioPlayers = (currentPlayer, currentAudio) => {
    document.querySelectorAll('[data-audio-compare]').forEach((otherPlayer) => {
      if (otherPlayer === currentPlayer) return;

      const otherBefore = otherPlayer.querySelector('[data-before]');
      const otherAfter = otherPlayer.querySelector('[data-after]');
      const otherToggle = otherPlayer.querySelector('[data-toggle]');
      const otherCard = otherPlayer.closest('.audio-example-card');

      [otherBefore, otherAfter].forEach((audio) => {
        if (audio && audio !== currentAudio && !audio.paused) audio.pause();
      });

      otherPlayer.classList.remove('is-playing');
      if (otherCard) otherCard.classList.remove('is-after-playing');
      if (otherToggle) {
        otherToggle.setAttribute('aria-label','Play audio');
        otherToggle.classList.remove('is-paused-icon');
      }
    });
  };

  window.MM212StopAudioPlayers = stopOtherAudioPlayers;

  document.querySelectorAll('[data-audio-compare]').forEach((player) => {
    const before = player.querySelector('[data-before]');
    const after = player.querySelector('[data-after]');
    const toggle = player.querySelector('[data-toggle]');
    const seek = player.querySelector('[data-seek]');
    const mode = player.querySelector('[data-mode]');
    const waveform = player.querySelector('[data-player-waveform]');
    const card = player.closest('.audio-example-card');
    if (!before || !after || !toggle || !seek) return;
    let active = before;
    player.dataset.activeMode = 'before';
    const setPlayingState = (isPlaying) => {
      player.classList.toggle('is-playing', isPlaying);
      if (card) card.classList.toggle('is-after-playing', isPlaying && player.dataset.activeMode === 'after');
    };
    const updateWaveProgress = () => {
      if (!waveform || !active.duration) return;
      const pct = Math.max(0, Math.min(100, (active.currentTime / active.duration) * 100));
      waveform.style.setProperty('--wave-progress', pct + '%');
    };
    const sync = (from, to) => { if (Math.abs((to.currentTime||0)-(from.currentTime||0)) > .15) to.currentTime = from.currentTime||0; };
    toggle.addEventListener('click', async () => {
      if (active.paused) { try { await active.play(); toggle.setAttribute('aria-label','Pause audio'); toggle.classList.add('is-paused-icon'); setPlayingState(true); } catch(e){} }
      else { active.pause(); toggle.setAttribute('aria-label','Play audio'); toggle.classList.remove('is-paused-icon'); setPlayingState(false); }
    });
    player.querySelectorAll('[data-switch]').forEach(btn => btn.addEventListener('click', async () => {
      const next = btn.dataset.switch === 'after' ? after : before;
      const wasPlaying = !active.paused;
      sync(active,next); active.pause(); active = next;
      mode.textContent = btn.dataset.switch === 'after' ? 'After' : 'Before';
      player.dataset.activeMode = btn.dataset.switch === 'after' ? 'after' : 'before';
      setPlayingState(wasPlaying);
      updateWaveProgress();
      if (wasPlaying) { try { await active.play(); setPlayingState(true); } catch(e){} }
    }));
    [before,after].forEach(a => {
      a.addEventListener('timeupdate', () => { if (a===active && a.duration) { seek.value=(a.currentTime/a.duration)*100; updateWaveProgress(); } });
      a.addEventListener('play', () => {
        if (a===active) {
          if (window.MM212PauseVideoPlayers) window.MM212PauseVideoPlayers();
          stopOtherAudioPlayers(player, a);
          setPlayingState(true);
        }
      });
      a.addEventListener('pause', () => { if (a===active) setPlayingState(false); });
      a.addEventListener('ended', () => { toggle.setAttribute('aria-label','Play audio'); toggle.classList.remove('is-paused-icon'); setPlayingState(false); updateWaveProgress(); });
    });
    seek.addEventListener('input', () => { if(active.duration){ const t=(seek.value/100)*active.duration; before.currentTime=t; after.currentTime=t; updateWaveProgress(); } });
  });
});


/* 212 global media playback — one audio/video source at a time */
(() => {
  const youtubeIframes = Array.from(document.querySelectorAll('[data-mm-youtube]'));
  const vimeoIframes = Array.from(document.querySelectorAll('[data-mm-vimeo]'));
  const youtubePlayers = new Map();

  const pauseVimeo = (exceptIframe = null) => {
    vimeoIframes.forEach((iframe) => {
      if (iframe === exceptIframe || !iframe.contentWindow) return;
      iframe.contentWindow.postMessage({method:'pause'}, '*');
    });
  };

  const pauseYouTube = (exceptIframe = null) => {
    youtubePlayers.forEach((player, iframe) => {
      if (iframe === exceptIframe) return;
      try { player.pauseVideo(); } catch(e) {}
    });
  };

  window.MM212PauseVideoPlayers = (exceptIframe = null) => {
    pauseYouTube(exceptIframe);
    pauseVimeo(exceptIframe);
  };

  const stopAudio = () => {
    if (window.MM212StopAudioPlayers) window.MM212StopAudioPlayers(null, null);
    document.querySelectorAll('[data-audio-compare] audio').forEach((audio) => {
      if (!audio.paused) audio.pause();
    });
  };

  const onVideoPlay = (iframe) => {
    stopAudio();
    window.MM212PauseVideoPlayers(iframe);
  };

  const initYouTubePlayers = () => {
    if (!youtubeIframes.length || !window.YT || !window.YT.Player) return false;
    youtubeIframes.forEach((iframe) => {
      if (youtubePlayers.has(iframe)) return;
      try {
        const player = new window.YT.Player(iframe, {
          events: {
            onStateChange: (event) => {
              if (event.data === window.YT.PlayerState.PLAYING) onVideoPlay(iframe);
            }
          }
        });
        youtubePlayers.set(iframe, player);
      } catch(e) {}
    });
    return true;
  };

  if (youtubeIframes.length) {
    if (!initYouTubePlayers()) {
      if (!document.querySelector('script[data-mm-youtube-api]')) {
        const tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.async = true;
        tag.dataset.mmYoutubeApi = 'true';
        document.head.appendChild(tag);
      }
      const existingReady = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = () => {
        if (typeof existingReady === 'function') {
          try { existingReady(); } catch(e) {}
        }
        initYouTubePlayers();
      };
      let tries = 0;
      const timer = setInterval(() => {
        tries += 1;
        if (initYouTubePlayers() || tries > 80) clearInterval(timer);
      }, 250);
    }
  }

  if (vimeoIframes.length) {
    const subscribeVimeo = (iframe) => {
      if (!iframe.contentWindow) return;
      iframe.contentWindow.postMessage({method:'addEventListener', value:'play'}, '*');
    };
    vimeoIframes.forEach((iframe) => {
      iframe.addEventListener('load', () => subscribeVimeo(iframe));
      subscribeVimeo(iframe);
    });

    window.addEventListener('message', (event) => {
      if (!String(event.origin || '').includes('vimeo.com')) return;
      let data = event.data;
      if (typeof data === 'string') {
        try { data = JSON.parse(data); } catch(e) { return; }
      }
      if (!data || data.event !== 'play') return;

      const iframe = vimeoIframes.find((candidate) =>
        candidate.contentWindow === event.source ||
        candidate.id === data.player_id
      );
      if (iframe) onVideoPlay(iframe);
    });
  }
})();

/* 212 AJAX cart drawer */
(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const overlay = document.querySelector('[data-cart-overlay]');
  if (!drawer || !overlay) return;

  const itemsEl = drawer.querySelector('[data-cart-items]');
  const totalEl = drawer.querySelector('[data-cart-total]');
  const statusEl = drawer.querySelector('[data-cart-status]');
  const root = (window.MM212 && window.MM212.root) || '/';
  const moneyFormat = (window.MM212 && window.MM212.moneyFormat) || '${{amount}}';

  const formatMoney = (cents) => {
    const value = (Number(cents || 0) / 100).toFixed(2);
    if (moneyFormat.includes('{{amount_no_decimals}}')) return moneyFormat.replace('{{amount_no_decimals}}', String(Math.round(Number(cents || 0) / 100)));
    if (moneyFormat.includes('{{amount}}')) return moneyFormat.replace('{{amount}}', value);
    return '$' + value;
  };

  const escapeHtml = (str) => String(str ?? '').replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));

  const openCart = () => {
    overlay.hidden = false;
    requestAnimationFrame(() => {
      overlay.classList.add('is-open');
      drawer.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('mm-cart-lock');
    document.body.classList.add('mm-cart-lock');
    const close = drawer.querySelector('[data-cart-close]');
    if (close) close.focus({preventScroll:true});
  };

  const closeCart = () => {
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mm-cart-lock');
    document.body.classList.remove('mm-cart-lock');
    window.setTimeout(() => { overlay.hidden = true; }, 280);
  };

  const renderCart = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return;
    totalEl.textContent = formatMoney(cart.total_price);
    document.querySelectorAll('.mm-cart-count').forEach(el => {
      el.textContent = cart.item_count;
      el.setAttribute('aria-label', `${cart.item_count} items in cart`);
    });
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p class="mm-cart-empty">Your cart is empty.</p>';
      return;
    }
    itemsEl.innerHTML = cart.items.map(item => {
      const titleKey = String(item.product_title || '').toLowerCase();
      const serviceArtwork = (window.MM212 && window.MM212.serviceArtwork) || {};
      let imageUrl = item.image || '';
      if (titleKey.includes('2-track') || titleKey.includes('2 track')) imageUrl = serviceArtwork.twoTrack || imageUrl;
      else if (titleKey.includes('stem')) imageUrl = serviceArtwork.fullStem || imageUrl;
      else if (titleKey.includes('master')) imageUrl = serviceArtwork.mastering || imageUrl;
      const image = imageUrl ? `<img class="mm-cart-item-image" src="${escapeHtml(imageUrl)}" alt="${escapeHtml(item.product_title || '')}">` : '<div class="mm-cart-item-image"></div>';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="mm-cart-item-meta">${escapeHtml(item.variant_title)}</div>` : '';
      const qtyControl = `
        <div class="mm-cart-qty" data-cart-qty>
          <button type="button" data-cart-qty-minus data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity}" aria-label="${item.quantity <= 1 ? 'Remove' : 'Decrease quantity of'} ${escapeHtml(item.product_title || '')}" style="width:28px;height:28px;border:1px solid rgba(255,255,255,.12);border-radius:8px;background:rgba(255,255,255,.035);color:#f4f0e8;cursor:pointer;font-size:18px;line-height:1;">−</button>
          <span aria-label="Quantity ${item.quantity}" style="min-width:22px;text-align:center;font-size:13px;font-weight:700;color:#f4f0e8;">${item.quantity}</span>
          <button type="button" data-cart-qty-plus data-key="${escapeHtml(item.key)}" data-quantity="${item.quantity}" aria-label="Increase quantity of ${escapeHtml(item.product_title || '')}" style="width:28px;height:28px;border:1px solid rgba(255,255,255,.12);border-radius:8px;background:rgba(255,255,255,.035);color:#f4f0e8;cursor:pointer;font-size:18px;line-height:1;">+</button>
        </div>`;
      return `<div class="mm-cart-item">${image}<div><a class="mm-cart-item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>${variant}${qtyControl}</div><div class="mm-cart-item-price">${formatMoney(item.final_line_price)}</div></div>`;
    }).join('');
  };

  const syncDrawerQuickAdd = (cart) => {
    const productIds = new Set((cart.items || []).map(item => String(item.product_id)));
    drawer.querySelectorAll('[data-drawer-quick-card]').forEach(card => {
      card.classList.toggle('is-in-cart', productIds.has(String(card.dataset.productId || '')));
    });
  };

  const getCart = async () => {
    const res = await fetch(root + 'cart.js', {headers:{'Accept':'application/json'}});
    if (!res.ok) throw new Error('Could not load cart');
    const cart = await res.json();
    syncDrawerQuickAdd(cart);
    return cart;
  };

  /* Header cart icon: open the AJAX drawer on desktop and mobile. */
  const openHeaderCart = async () => {
    try {
      const cart = await getCart();
      renderCart(cart);
      openCart();
    } catch (error) {
      window.location.href = root + 'cart';
    }
  };

  window.MM212OpenCart = openHeaderCart;

  document.addEventListener('click', (event) => {
    const cartLink = event.target.closest('.mm-cart-link');
    if (!cartLink) return;
    event.preventDefault();
    event.stopPropagation();
    openHeaderCart();
  });

  const changeCartItem = async (key, quantity) => {
    const res = await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Accept':'application/json',
        'Content-Type':'application/json'
      },
      body: JSON.stringify({id:key, quantity:Math.max(0, Number(quantity) || 0)})
    });
    if (!res.ok) {
      const data = await res.json().catch(() => ({}));
      throw new Error(data.description || data.message || 'Could not update the cart.');
    }
    return res.json();
  };

  let quantityUpdateBusy = false;

  itemsEl.addEventListener('click', async (e) => {
    const minus = e.target.closest('[data-cart-qty-minus]');
    const plus = e.target.closest('[data-cart-qty-plus]');
    const button = minus || plus;
    if (!button || quantityUpdateBusy) return;

    const key = button.dataset.key;
    const current = Number(button.dataset.quantity || 1);
    const next = minus ? Math.max(0, current - 1) : current + 1;
    if (!key) return;

    quantityUpdateBusy = true;
    statusEl.textContent = 'Updating cart…';
    itemsEl.querySelectorAll('[data-cart-qty-minus],[data-cart-qty-plus]').forEach(btn => btn.disabled = true);
    try {
      const cart = await changeCartItem(key, next);
      renderCart(cart);
      statusEl.textContent = next === 0 ? 'Item removed.' : 'Cart updated.';
    } catch (err) {
      statusEl.textContent = err.message || 'Could not update the cart.';
    } finally {
      quantityUpdateBusy = false;
      itemsEl.querySelectorAll('[data-cart-qty-minus],[data-cart-qty-plus]').forEach(btn => btn.disabled = false);
    }
  });

  document.addEventListener('click', async (e) => {
    const minus = e.target.closest('[data-cart-page-minus]');
    const plus = e.target.closest('[data-cart-page-plus]');
    const button = minus || plus;
    if (!button || quantityUpdateBusy) return;

    const key = button.dataset.key;
    const current = Number(button.dataset.quantity || 1);
    const next = minus ? Math.max(0, current - 1) : current + 1;
    if (!key) return;

    quantityUpdateBusy = true;
    button.disabled = true;
    try {
      await changeCartItem(key, next);
      window.location.reload();
    } catch (err) {
      button.disabled = false;
      quantityUpdateBusy = false;
      const pageStatus = document.querySelector('[data-cart-page-status]');
      if (pageStatus) pageStatus.textContent = err.message || 'Could not update the cart.';
    }
  });

  drawer.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-drawer-quick-add]');
    if (!button || button.disabled) return;

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const quickStatus = drawer.querySelector('[data-drawer-quick-status]');
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = '…';
    if (quickStatus) quickStatus.textContent = 'Adding…';

    try {
      const res = await fetch(root + 'cart/add.js', {
        method:'POST',
        headers:{'Accept':'application/json','Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:variantId,quantity:1}]})
      });

      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.description || data.message || 'Could not add this product.');
      }

      const cart = await getCart();
      renderCart(cart);
      syncDrawerQuickAdd(cart);
      if (quickStatus) quickStatus.textContent = 'Added to cart.';
      window.setTimeout(() => { if (quickStatus) quickStatus.textContent = ''; }, 1600);
    } catch (error) {
      button.disabled = false;
      button.textContent = originalText;
      if (quickStatus) quickStatus.textContent = error.message || 'Could not add this product.';
    }
  });

  document.querySelectorAll('[data-cart-close]').forEach(btn => btn.addEventListener('click', closeCart));
  overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCart(); });

  document.querySelectorAll('form.product-212-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      // Let Shopify accelerated checkout buttons (Shop Pay / Apple Pay / Buy it now)
      // submit normally. Only the standard Add to Cart button should open our cart drawer.
      const submitter = e.submitter;
      if (submitter && submitter.name !== 'add') return;

      e.preventDefault();
      const button = form.querySelector('[name="add"]');
      if (!button || button.disabled) return;
      const original = button.textContent;
      button.disabled = true;
      button.classList.add('is-loading');
      button.textContent = 'Adding…';
      statusEl.textContent = '';
      try {
        const formData = new FormData(form);
        const mainVariantId = Number(formData.get('id'));
        const quantity = Number(formData.get('quantity') || 1);
        const addonIds = Array.from(form.querySelectorAll('[data-addon-variant-id]:checked'))
          .map(input => Number(input.dataset.addonVariantId))
          .filter(Boolean);

        let requestBody;
        let headers = {'Accept':'application/json'};
        if (addonIds.length) {
          headers['Content-Type'] = 'application/json';
          requestBody = JSON.stringify({
            items: [
              {id: mainVariantId, quantity},
              ...addonIds.map(id => ({id, quantity:1}))
            ]
          });
        } else {
          requestBody = formData;
        }

        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers,
          body: requestBody
        });
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || data.message || 'Could not add this item to cart.');
        }
        const cart = await getCart();
        renderCart(cart);
        openCart();
        statusEl.textContent = 'Added to cart.';
      } catch (err) {
        statusEl.textContent = err.message || 'Something went wrong. Please try again.';
        openCart();
      } finally {
        button.disabled = false;
        button.classList.remove('is-loading');
        button.textContent = original;
      }
    });
  });
})();


/* 212 cart page quick add */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-cart-quick-add]');
  if (!button) return;

  const variantId = Number(button.dataset.variantId);
  if (!variantId || button.disabled) return;

  const status = document.querySelector('[data-cart-quick-status]');
  button.disabled = true;
  const originalText = button.textContent;
  button.textContent = 'Adding…';
  if (status) status.textContent = 'Adding to your cart…';

  try {
    const root = (window.MM212 && window.MM212.root) || '/';
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({items:[{id:variantId,quantity:1}]})
    });

    if (!response.ok) {
      const data = await response.json().catch(() => ({}));
      throw new Error(data.description || data.message || 'Could not add this product.');
    }

    if (status) status.textContent = 'Added. Updating cart…';
    window.location.reload();
  } catch (error) {
    button.disabled = false;
    button.textContent = originalText;
    if (status) status.textContent = error.message || 'Could not add this product.';
  }
});

/* 212 site-wide predictive search */
(() => {
  const overlay = document.querySelector('[data-site-search]');
  if (!overlay) return;

  const input = overlay.querySelector('[data-search-input]');
  const results = overlay.querySelector('[data-search-results]');
  const hint = overlay.querySelector('[data-search-hint]');
  const openers = document.querySelectorAll('[data-search-open]');
  const closers = overlay.querySelectorAll('[data-search-close]');
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let timer;
  let controller;

  const openSearch = () => {
    overlay.hidden = false;
    requestAnimationFrame(() => overlay.classList.add('is-open'));
    document.documentElement.classList.add('mm-search-open');
    window.setTimeout(() => input && input.focus(), 80);
  };

  const closeSearch = () => {
    overlay.classList.remove('is-open');
    document.documentElement.classList.remove('mm-search-open');
    window.setTimeout(() => { overlay.hidden = true; }, 220);
  };

  openers.forEach(button => button.addEventListener('click', (event) => {
    event.preventDefault();
    openSearch();
  }));
  closers.forEach(button => button.addEventListener('click', closeSearch));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !overlay.hidden) closeSearch();
  });

  const renderStatus = (message) => {
    results.innerHTML = `<div class="mm-search-empty">${message}</div>`;
  };

  const runSearch = async () => {
    const query = input.value.trim();
    if (query.length < 2) {
      if (controller) controller.abort();
      results.innerHTML = '';
      hint.hidden = false;
      return;
    }

    hint.hidden = true;
    renderStatus('Searching…');
    if (controller) controller.abort();
    controller = new AbortController();

    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product,page,article',
      'resources[limit]': '6',
      section_id: 'predictive-search-212'
    });

    try {
      const response = await fetch(`${root}search/suggest?${params.toString()}`, {
        signal: controller.signal,
        headers: { Accept: 'text/html' }
      });
      if (!response.ok) throw new Error('Search request failed');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('#shopify-section-predictive-search-212');
      results.innerHTML = section ? section.innerHTML : '<div class="mm-search-empty">No results found.</div>';
    } catch (error) {
      if (error.name === 'AbortError') return;
      renderStatus('Search is temporarily unavailable. Press Enter to view full results.');
    }
  };

  input.addEventListener('input', () => {
    window.clearTimeout(timer);
    timer = window.setTimeout(runSearch, 180);
  });
})();
